import { defineMessages } from "react-intl";

export default defineMessages({
  sendARequest: {
    id: 'sendARequest',
    defaultMessage: 'Send a request'
  }
});